export default __webpack_public_path__ + "media/porto seguro_285px_111px-07.png";